import React, {Component} from 'react';
import {connect} from 'react-redux';
import {plainTranslate} from '../common/translate';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

class InvoicesInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
        };
    }

    render() {
        return (
            <div>
                <div className="account-profile-other-information-more">
                    <h4>{plainTranslate(this.props.settings.locale, 'Invoices')}</h4>
                    {this.props.invoices && this.props.invoices.length > 0 &&
                        <a className="account-profile-show" id="invoices" href="javascript:void(0)"
                           onClick={() => this.setState({show: !this.state.show})}>
                            {this.state.show ? <i className="glyphicon glyphicon-chevron-up"></i> :
                                <i className="glyphicon glyphicon-chevron-down"></i>}
                        </a>  
                    }
                    {
                        this.state.show &&
                        <div className="line">
                            <table  className="table">
                                <thead>
                                    <tr>
                                        <th>{plainTranslate(this.props.settings.locale, '#')}</th>
                                        <th>{plainTranslate(this.props.settings.locale, 'Date')}</th>
                                        <th>{plainTranslate(this.props.settings.locale, 'Location')}</th>
                                        <th>{plainTranslate(this.props.settings.locale, 'Amount')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.invoices.map(invoice=>
                                        <tr>
                                            <td>
                                                {invoice.hasView
                                                    ? <Link to={'/' + this.props.match.params.db +'/sale/'+invoice.secureId+'/profile?tab=invoice'}>{invoice.no}</Link>
                                                    : invoice.no
                                                }
                                            </td>
                                            <td>{invoice.date ? moment((invoice.date).replaceAll('.', '/'), 'DD/MM/YYYY').format(this.props.settings.dateFormat) : ''}</td>
                                            <td>{invoice.location}</td>
                                            <td>{parseFloat(invoice.amount).toFixed(2)}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
                <div className="separate"></div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    settings: state.settings,
});
const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoicesInfo));
